import React, { Component } from 'react';
import {
  BarChart, Bar, ResponsiveContainer, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
  Pie, PieChart, Line, LineChart
} from 'recharts';
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'
import './Overviews.css'
import ComboboxInput from './ComboboxInputCustom'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment'
import { toast } from "react-toastify";

import ActionGetAccessModule from '../../store/action/AccessModule/Fetch'
import ActionGetAllSender from '../../store/action/Sender/FetchAll'
import ActionBotInquiry from '../../store/action/PushInteractive/FetchBotInquiry'
import ActionInteractiveSummary from '../../store/action/PushInteractive/FetchInteractiveSummary'
import ActionGetTotalTicket from '../../store/action/PushInteractive/FetchTotalTicket'
import ActionGetTicketHour from '../../store/action/PushInteractive/FetchTicketByHour'
import ActionGetTicketTopic from '../../store/action/PushInteractive/FetchTicketTopic'
import ActionGetAverage from '../../store/action/PushInteractive/FetchAverageResponseResolve'
import ActionGetTicketDay from '../../store/action/PushInteractive/FetchTicketDay'
import ActionGetVolumeBot from '../../store/action/PushInteractive/FetchChatBotVolume'
import ActionGetClient from '../../store/action/Client/FetchAll'
import ActionFindByGroupId from '../../store/action/Previlage/FindByGroupId'
import { ClientId, SenderId, PrevilageId } from "../../helper/HelperAuth";

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div>
        <p className="labels">No Topic : 0</p>
      </div>
    );
  }

  return null;
};

class Page extends Component {

  constructor(props) {
    super(props)
    this.state = {
      form: fromJS({
        'client': ClientId,
        'sender': SenderId,
        'tahun': "",
        'bulan': "",
        'tanggal-mulai': "",
        'tanggal-selesai': ""
      }),
      isadmin:false,
      colhide: '',
      hideclient: '',
      databot: "",
      datatotalticket: "",
      datatickethour: "",
      datatickettopic: "",
      dataaverage: "",
      dataticketday: "",
      datavolumebot: "",
      onprocess: "",
      closed: "",
      totalticket: "",
      newticket: "",
      queue: "",
      dates: moment().format('D MMMM YYYY') + " - " + moment().format('D MMMM YYYY'),
      initstart: moment().format('MM/D/YYYY').toString(),
      initend: moment().format('MM/D/YYYY').toString(),
      intertotick: 0,
      interinquiry: 0,
      interaverage: 0,
      tooltip: "",
      tooltipvolume: "",
      angletick: "-60",
      angleinquiry: "-60",
      angleaverage: "-60",
      anchorinqu: "end",
      anchortick: "end",
      anchoraver: "end",
      loaderStyle: {},
      dissender: true
    };

    this.handleChange = this.handleChange.bind(this)
    this.handleref = this.handleref.bind(this)
    this.handleCallback = this.handleCallback.bind(this)
    this.handlebody = this.handlebody.bind(this)
  }

  handleChange(field, value, label) {
    var formVal = this.state.form
    if (value == null) value = ""
    if (field == 'client') {
      this.props.actionGetAllSender(value)
      formVal = formVal.set('sender', '')
    }
    if (field == 'sender') {
      if (PrevilageId == 1 || this.state.isadmin == true) {
        if (value == "") {
          toast.error("Sender cannot empty", toast.POSITION.BOTTOM_RIGHT)
          formVal = formVal.set('sender', '')
          formVal = formVal.set(field, value)
          this.setState({ form: formVal })
          return false
        }
      } else {
        if (value == "") {
          toast.error("Sender cannot empty", toast.POSITION.BOTTOM_RIGHT)

          this.setState({ form: formVal })
          return false
        }
      }
    }
    formVal = formVal.set(field, value)
    this.setState({ form: formVal })
    if (formVal.get('sender') == "") {
      toast.warn('Sender cannot be empty');
    } else {
      this.handleref(this.state.initstart,
        this.state.initend, formVal.get('sender'))
    }
  }

  async componentDidMount() {
    var formVal = this.state.form
    var isAdmin = await this.props.actionFindByGroupId();
    this.setState({isadmin:isAdmin})

    if (PrevilageId > 1 && isAdmin == false) {
      this.setState({ hideclient: 'hide', colhide: 'cols-sm-9' })
    } else {
      this.setState({ hideclient: '', colhide: 'cols-sm-6' })
    }
    this.props.actionGetClient();
    this.props.actionGetAllSender(ClientId)
    await this.props.actionGetAccessModule(PrevilageId);
    let restrict = this.handleActionId()
    let dissen = this.state.dissender
    if (restrict == 5) dissen = true
    else dissen = false
    this.handleref(this.state.initstart, this.state.initend, this.state.form.get("sender"))
    this.setState({ dissender: dissen })
  }


  async handleref(start, end, sender) {
    await this.handlebody(start, end, sender)
    const { form } = this.state
    var tooltip = this.state.tooltip
    var tooltipvol = this.state.tooltipvolume
    var intertotick = this.state.intertotick
    var interinquiry = this.state.interinquiry
    var interaverage = this.state.interaverage
    var angletick = this.state.angletick
    var angleinquiry = this.state.angleinquiry
    var angleaverage = this.state.angleaverage
    var anchortick = this.state.anchortick
    var anchorinqu = this.state.anchorinqu
    var anchoraver = this.state.anchoraver

    var body = {
      "sender": form.get("sender"),
      "tahun": form.get("tahun"),
      "bulan": form.get("bulan"),
      "tanggal-mulai": form.get("tanggal-mulai"),
      "tanggal-selesai": form.get("tanggal-selesai")
    }
    //debugger
    if (form.get("client") == null 
    || form.get("client") == "" 
    || form.get("sender") == null
    || form.get("sender") == "") return false, toast.error("Client or Sender Cannot Be Empty", toast.POSITION.BOTTOM_RIGHT)

    var databot = await this.props.actionBotInquiry(body)
    var datainteractive = await this.props.actionInteractiveSummary(body)
    var totalstickets = await this.props.actionGetTotalTicket(body)
    var tickethour = await this.props.actionGetTicketHour(body)
    var tickettopics = await this.props.actionGetTicketTopic(body)
    var averag = await this.props.actionGetAverage(body)
    var ticketsday = await this.props.actionGetTicketDay(body)
    var volume = await this.props.actionGetVolumeBot(body)

    if (tickettopics[0].name == "No Topic") tooltip = <CustomTooltip />
    else tooltip = ""

    if (volume[0].name == "No Topic") tooltipvol = <CustomTooltip />
    else tooltipvol = ""

    if (totalstickets.length >= 0 && totalstickets.length <= 10) {
      intertotick = 0
      if (totalstickets.length <= 3) {
        angletick = "0"; 
        anchortick = "middle"
      } else {
        angletick = "-60";
        anchortick = "end";
      }
    } else if (totalstickets.length > 10 && totalstickets.length <= 20) {
      intertotick = 1; 
      angletick = "-60"; 
      anchortick = "end";
    } else if (totalstickets.length > 20) {
      intertotick = 2; 
      angletick = "-60"; 
      anchortick = "end";
    }

    if (databot.length >= 0 && databot.length <= 10) {
      interinquiry = 0
      if (databot.length <= 3) {
        angleinquiry = "0" 
        anchorinqu = "middle"
      } else {
        angleinquiry = "-60" 
        anchorinqu = "end"
      }
    } else if (databot.length > 10 && databot.length <= 20) {
      interinquiry = 1 
      angleinquiry = "-60" 
      anchorinqu = "end"
    }
    else if (databot.length > 20) {
      interinquiry = 2
      angleinquiry = "-60"
      anchorinqu = "end"
    }

    if (averag.length > 0 && averag.length <= 10) {
      interaverage = 0
      if (averag.length <= 3) {
        angleaverage = "0"
        anchoraver = "middle"
      } else {
        angleaverage = "-60" 
        anchoraver = "end"
      }
    } else if (averag.length > 10 && averag.length <= 20) {
      interaverage = 1
      angleaverage = "-60" 
      anchoraver = "end"
    } else if (averag.length > 20) {
      interaverage = 2
      angleaverage = "-60"
      anchoraver = "end"
    }


    this.setState({
      databot: databot,
      datatotalticket: totalstickets,
      datatickethour: tickethour,
      datatickettopic: tickettopics,
      dataaverage: averag,
      dataticketday: ticketsday,
      datavolumebot: volume,
      onprocess: datainteractive.get("onprocess-tickets"),
      closed: datainteractive.get("closed-tickets"),
      totalticket: datainteractive.get("total-tickets"),
      newticket: datainteractive.get("new-tickets"),
      queue: datainteractive.get("queue-tickets"),
      intertotick: intertotick,
      interinquiry: interinquiry,
      interaverage: interaverage,
      tooltip: tooltip,
      tooltipvolume: tooltipvol,
      angletick: angletick,
      angleinquiry: angleinquiry,
      angleaverage: angleaverage,
      anchortick: anchortick,
      anchorinqu: anchorinqu,
      anchoraver: anchoraver,
      loaderStyle: { display: 'none' },
    })
  }

  handleCallback(start, end, label) {
    var starts = start.format('MM/D/YYYY').toString()
    var ends = end.format('MM/D/YYYY').toString()
    var dated = start.format('D MMMM YYYY') +
      " - " + end.format('D MMMM YYYY')
    var arraystart = starts.split("/")
    var arrayend = ends.split("/")
    if (arraystart[0] != arrayend[0]) {
      toast.error("Cannot cross month only accepted range date with same month", toast.POSITION.BOTTOM_RIGHT)
      return false
    }


    this.handleref(starts, ends, this.state.form.get("sender"))
    this.setState({ dates: dated, initstart: starts, initend: ends })
  }

  handlebody(start, end, sender) {
    var formVal = this.state.form
    var arraystart = start.split("/")
    var arrayend = end.split("/")
    var bulan = arraystart[0]
    var tahun = arraystart[2]
    var tglstart = arraystart[1]
    var tglend = arrayend[1]

    if (arraystart[0] != arrayend[0]) {
      toast.error("Cannot cross month only accepted range date with same month", toast.POSITION.BOTTOM_RIGHT)
      return false
    }
    if (sender == undefined || sender == null || sender == 'null' || sender == "") {
     // toast.error("Sender cannot be empty", toast.POSITION.BOTTOM_RIGHT)
      return false
    }
    
    if (bulan[0] == "0") bulan = bulan[1]

    if (tglstart[0] == "0") tglstart = tglstart[0]

    if (tglend[0] == "0") tglend = tglend[0]
    
    formVal = formVal.set("tahun", tahun)
      .set("bulan", bulan)
      .set("tanggal-mulai", tglstart)
      .set("tanggal-selesai", tglend)
      .set("sender", sender)
    this.setState({
      form: formVal,
      loaderStyle: {}
    })

  }

  handleActionId() {
    let array = []
    let action = 0;
    let menuPrev = (this.props.accessmodules.get('data') != null ? this.props.accessmodules.get('data') : fromJS([]));
    {
      menuPrev.map((data, i) =>
        array.push({
          'menu-name': data.get('menu-name'),
          'action-id': data.get('action-id')
        })

      )
    }

    for (let i = 0; i < array.length; i++) {
      if (array[i]['menu-name'] === 'Push Interactive') {
        action = array[i]['action-id'];
        this.state.action_id = array[i]['action-id'];
      }
    }
    return action;
  }

  render() {
    const { form, loaderStyle } = this.state;
    return (
      <div>
        <div className="page-loader-wrapper" style={loaderStyle}>
          <div className="loader">
            <div className="preloader">
              <div className="spinner-layer pl-orange">
                <div className="circle-clipper left">
                  <div className="circle"></div>
                </div>
                <div className="circle-clipper right">
                  <div className="circle"></div>
                </div>
              </div>
            </div>
            <p>Please wait...</p>
          </div>
        </div>
        <div className="content-header">
          <div className="containers-fluid">
            <div className="rows mb-2">
              <div className="cols-sm-4">
                <h1 className="m-0 titles-card-head">Interactive Dashboard</h1>
              </div>
            </div>
            <div className="rows mb-2">
              <div className={this.state.colhide}>
                <DateRangePicker
                  initialSettings={{
                    startDate: this.state.initstart,
                    endDate: this.state.initend,
                    ranges: {
                      Today: [moment().toDate(), moment().toDate()],
                      Yesterday: [
                        moment().subtract(1, 'days').toDate(),
                        moment().subtract(1, 'days').toDate(),
                      ],
                      'Last 7 Days': [
                        moment().subtract(6, 'days').toDate(),
                        moment().toDate(),
                      ],
                      'Last 30 Days': [
                        moment().subtract(29, 'days').toDate(),
                        moment().toDate(),
                      ],
                      'This Month': [
                        moment().startOf('month').toDate(),
                        moment().endOf('month').toDate(),
                      ],
                      'Last Month': [
                        moment().subtract(1, 'month').startOf('month').toDate(),
                        moment().subtract(1, 'month').endOf('month').toDate(),
                      ],
                    }
                  }}
                  onCallback={this.handleCallback}
                >
                  <div class="cols-sm-12 floats-right calendar">
                    <i class="fa fa-calendar"></i>&nbsp;&nbsp;
                    <span>{this.state.dates}</span> <i class="fa fa-caret-down"></i>
                  </div>
                </DateRangePicker>

              </div>
              <div className={`forms-groups cols-sm-3 floats-right ${this.state.hideclient}`}>
                <ComboboxInput
                  field='client'
                  value={this.state.form.get('client')}
                  options={fromJS({
                    'source': this.props.clientall,
                    'value': 'client-id',
                    'label': 'client-name'
                  })}
                  onChange={(field, value, label) => this.handleChange(field, value, label)}
                  disabled={this.state.dissender}
                  placeholder="Client"
                />
              </div>
              <div className="forms-groups cols-sm-3 floats-right ">

                <ComboboxInput
                  field='sender'
                  value={this.state.form.get('sender')}
                  options={fromJS({
                    'source': this.props.senderall,
                    'value': 'sender-id',
                    'label': 'sender-id-name'
                  })}
                  onChange={(field, value, label) => this.handleChange(field, value, label)}
                  disabled={this.state.dissender}
                  placeholder="Sender"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="content-header">
          <div className="containers-fluid">
            <div className="rows mb-2">
              <div className="cols-sm-12">
                <h1 className="m-0 titles-card-child">ChatBot</h1>
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="containers-fluid">
            <div className="rows">
              <div className="cols-lg-12">
                <div className="content">
                  <div className="rows">
                    <div className="cols-lg-6">
                      <div className="cards">
                        <div className="cards-header border-0">
                          <div className="d-flex justify-content-between">
                            <h3 className="cards-title">ChatBot Inquiry Answered</h3>
                          </div>
                        </div>
                        <div className="cards-body">
                          <ResponsiveContainer width='100%' height={300}>
                            <BarChart
                              height={300}
                              data={this.state.databot}
                              margin={{
                                top: 20, right: 0, left: -15, bottom: 10,
                              }}
                              barGap={70}
                            >
                              <CartesianGrid
                                strokeDasharray="0 100" />
                              <XAxis dataKey="name"
                                angle={this.state.angleinquiry}
                                dy="20"
                                axisLine={false}
                                tickLine={false}
                                height={80}
                                interval={this.state.interinquiry}
                                tick={{ fontSize: 13, fontWeight: "bold" }}
                                textAnchor={this.state.anchorinqu} />
                              <YAxis axisLine={false}
                                tickLine={false} />
                              <Tooltip cursor={{ fill: 'transparent' }} />
                              <Bar dataKey="Bot Inquiry Answered"
                                stackId="a" barSize={50}
                                fill="#F9B03C" />
                            </BarChart>
                          </ResponsiveContainer>
                        </div>
                      </div>
                    </div>
                    <div className="cols-lg-6">
                      <div className="cards">
                        <div className="cards-header border-0">
                          <div className="d-flex justify-content-between">
                            <h3 className="cards-title">ChatBot Volume</h3>
                          </div>
                        </div>
                        <div className="cards-body">
                          <div className="position-relative mb-4">
                            <ResponsiveContainer width='100%' height={285}>
                              <PieChart
                                height={285}>
                                <Pie
                                  data={this.state.datavolumebot}
                                  dataKey="Volume ChatBot"
                                  nameKey="name"
                                  innerRadius={50}
                                  outerRadius={100}
                                  margin={{
                                    top: 20, right: 10, left: -40, bottom: 10,
                                  }}
                                />
                                <Tooltip content={this.state.tooltipvolume} />
                                <Legend verticalAlign="middle"
                                  layout="vertical"
                                  align="right"
                                  iconSize={30} />
                              </PieChart>
                            </ResponsiveContainer>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="content-header">
                  <div className="rows mb-2">
                    <div className="cols-sm-12">
                      <h1 className="m-0 titles-card-child">Tickets</h1>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-2">
                    <div className="smalls-box orange">
                      <div className="inner">
                        <h3>{this.state.totalticket}</h3>
                        <p className="titles-card" style={{ color: "#ffffff" }}>Total Tickets</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-2">
                    <div className="smalls-box white">
                      <div className="inner">
                        <h3>{this.state.queue}</h3>
                        <p className="titles-card">Queue Tickets</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-2">
                    <div className="smalls-box white">
                      <div className="inner">
                        <h3>{this.state.newticket}</h3>
                        <p className="titles-card">New Tickets</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-2">
                    <div className="smalls-box white">
                      <div className="inner">
                        <h3>{this.state.onprocess}</h3>
                        <p className="titles-card">On Process Tickets</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-2">
                    <div className="smalls-box white">
                      <div className="inner">
                        <h3>{this.state.closed}</h3>
                        <p className="titles-card"> Close Tickets</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="content">
                  <div className="rows">
                    <div className="cols-lg-4">
                      <div className="cards">
                        <div className="cards-header border-0">
                          <div className="d-flex justify-content-between">
                            <h3 className="cards-title">Total Tickets</h3>
                          </div>
                        </div>
                        <div className="cards-body">
                          <div className="position-relative mb-4">
                            <ResponsiveContainer width='100%' height={300}>
                              <BarChart
                                height={300}
                                data={this.state.datatotalticket}
                                margin={{
                                  top: 20, right: 0, left: -30, bottom: 10,
                                }}
                                barCategoryGap={2}
                              >
                                <CartesianGrid
                                  strokeDasharray="0 100" />
                                <XAxis
                                  dataKey="name"
                                  angle={this.state.angletick}
                                  dy="100" height={60}
                                  axisLine={false}
                                  tickLine={false}
                                  textAnchor={this.state.anchortick}
                                  tick={{ fontSize: 10, fontWeight: "bold" }}
                                  interval={this.state.intertotick} />
                                <YAxis
                                  axisLine={false}
                                  tickLine={false} />
                                <Tooltip
                                  cursor={{ fill: 'transparent' }} />
                                <Bar dataKey="TotalTickets"
                                  fill="#F39C12" />
                              </BarChart>
                            </ResponsiveContainer>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="cols-lg-4">
                      <div className="cards">
                        <div className="cards-header border-0">
                          <div className="d-flex justify-content-between">
                            <h3 className="cards-title">Total Tickets by Day</h3>
                          </div>
                        </div>
                        <div className="cards-body">
                          <div className="position-relative mb-4">
                            <ResponsiveContainer width='100%' height={300}>
                              <BarChart
                                height={300}
                                data={this.state.dataticketday}
                                margin={{
                                  top: 20, right: 0, left: -30, bottom: 10,
                                }}
                                barCategoryGap={2}
                              >
                                <CartesianGrid
                                  strokeDasharray="0 100" />
                                <XAxis
                                  dataKey="name"
                                  angle="0"
                                  verticalAlign="center"
                                  height={60}
                                  axisLine={false}
                                  tickLine={false}
                                  width={30}
                                  tick={{ fontSize: 15, fontWeight: "bold" }}
                                  interval={0} />
                                <YAxis
                                  axisLine={false}
                                  tickLine={false} />
                                <Tooltip cursor={{ fill: 'transparent' }} />
                                <Bar
                                  dataKey="total-tickets"
                                  fill="#F39C12" />
                              </BarChart>
                            </ResponsiveContainer>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="cols-lg-4">
                      <div className="cards">
                        <div className="cards-header border-0">
                          <div className="d-flex justify-content-between">
                            <h3 className="cards-title">Total Tickets by Hour</h3>
                          </div>
                        </div>
                        <div className="cards-body">
                          <div className="position-relative mb-4">
                            <ResponsiveContainer width='100%' height={300}>
                              <LineChart
                                height={300}
                                data={this.state.datatickethour}
                                margin={{
                                  top: 20, right: 10, left: -25, bottom: 10,
                                }}

                              >
                                <CartesianGrid
                                  strokeDasharray="0 1000" />
                                <XAxis dataKey="name"
                                  angle="-45"
                                  dy="100"
                                  height={60}
                                  axisLine={false}
                                  tickLine={false}
                                  tick={{ fontSize: 15, fontWeight: "bold" }}
                                  interval={1}
                                  padding={{ left: 10, right: 0 }}
                                  textAnchor="end"
                                />
                                <YAxis axisLine={false}
                                  tickLine={false} />
                                <Tooltip cursor={{ fill: 'transparent' }} />
                                <Line dataKey="total-tickets"
                                  fill="#F39C12"
                                  stroke="#F39C12"
                                  strokeWidth={3} />
                              </LineChart>
                            </ResponsiveContainer>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="content">
                  <div className="rows">
                    <div className="cols-lg-6">
                      <div className="cards">
                        <div className="cards-header border-0">
                          <div className="d-flex justify-content-between">
                            <h3 className="cards-title">Response and Resolve Time Rate</h3>
                          </div>
                        </div>
                        <div class="d-flex mb-4">
                          <span class="mr-2">
                            <i class="fas fa-square" style={{ color: "#65a0d1" }}></i> Avg. Respond Time in Minute
                          </span>
                          <span class="mr-2">
                            <i class="fas fa-square" style={{ color: "#F39C12" }}></i> Avg. Resolve Time in Minute
                          </span>
                        </div>
                        <div className="cards-body">
                          <div className="position-relative mb-4">
                            <ResponsiveContainer width='100%' height={280}>
                              <LineChart
                                height={280}
                                data={this.state.dataaverage}
                                margin={{
                                  top: 20, right: 10, left: 20, bottom: 10,
                                }}
                                CategoryGap={0}
                              >
                                <CartesianGrid
                                  strokeDasharray="0 1000" />
                                <XAxis
                                  dataKey="name"
                                  angle={this.state.angleaverage}
                                  dy="100" height={100}
                                  axisLine={false}
                                  tickLine={false}
                                  textAnchor={this.state.anchoraver}
                                  tick={{ fontSize: 10, fontWeight: "bold" }}
                                  interval={this.state.interaverage} />
                                <YAxis
                                  axisLine={false}
                                  tickLine={false} />
                                <Tooltip cursor={{ fill: 'transparent' }} />
                                <Line
                                  name="Avg. Resolve Time in Minute"
                                  dataKey="resolve"
                                  fill="#F39C12"
                                  stroke="#F39C12"
                                  strokeWidth={3} />
                                <Line
                                  name="Avg. Response Time in Minute"
                                  dataKey="response"
                                  fill="#65a0d1"
                                  stroke="#65a0d1"
                                  strokeWidth={3} />
                              </LineChart>
                            </ResponsiveContainer>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="cols-lg-6">
                      <div className="cards">
                        <div className="cards-header border-0">
                          <div className="d-flex justify-content-between">
                            <h3 className="cards-title">Tickets Topic</h3>
                          </div>
                        </div>
                        <div className="cards-body">
                          <div className="position-relative mb-4">
                            <ResponsiveContainer width='100%' height={315}>
                              <PieChart
                                height={315}>
                                <Pie
                                  data={this.state.datatickettopic}
                                  dataKey="total"
                                  nameKey="name"
                                  innerRadius={50}
                                  outerRadius={100}
                                  margin={{
                                    top: 20, right: 10, left: -20, bottom: 10,
                                  }}
                                />
                                <Tooltip
                                  content={this.state.tooltip} />
                                <Legend
                                  verticalAlign="middle"
                                  layout="vertical"
                                  align="right" />
                              </PieChart>
                            </ResponsiveContainer>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="cols-lg-5 connectedSortable">

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => {
    return {
      botinquirys: state.user.botinquiry,
      interactve: state.user.interactivesummary,
      tickets: state.user.totalsticket,
      tickethour: state.user.ticketshour,
      tickettopic: state.user.ticketstopic,
      averages: state.user.average,
      ticketdays: state.user.ticketday,
      senderall: state.user.senders,
      volumebots: state.user.volumebot,
      accessmodules: state.user.accessmodules,
      clientall: state.user.clientall,
    }
  },
  dispatch => bindActionCreators({
    actionGetAccessModule: ActionGetAccessModule,
    actionBotInquiry: ActionBotInquiry,
    actionInteractiveSummary: ActionInteractiveSummary,
    actionGetTotalTicket: ActionGetTotalTicket,
    actionGetTicketHour: ActionGetTicketHour,
    actionGetTicketTopic: ActionGetTicketTopic,
    actionGetAverage: ActionGetAverage,
    actionGetTicketDay: ActionGetTicketDay,
    actionGetAllSender: ActionGetAllSender,
    actionGetVolumeBot: ActionGetVolumeBot,
    actionGetClient: ActionGetClient,
    actionFindByGroupId:ActionFindByGroupId
  }, dispatch),
)(Page);